var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignupArrs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-arrow",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 16,
    viewBox: "0 0 33 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-arrow"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29703",
    "data-name": "Rectangle 29703",
    width: 16,
    height: 16,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29704",
    "data-name": "Rectangle 29704",
    width: 15,
    height: 16,
    transform: "translate(0.471)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29705",
    "data-name": "Rectangle 29705",
    width: 16,
    height: 16,
    transform: "translate(-0.117)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15942",
    "data-name": "Group 15942",
    transform: "translate(-204 -515.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_754",
    "data-name": "Mask Group 754",
    transform: "translate(204 515.5)",
    opacity: 0.5,
    clipPath: "url(#clip-path-arrow)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_16_",
    "data-name": "svgexport-7 (16)",
    transform: "translate(2.666 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9429",
    d: "M11.23,1491.206a1.067,1.067,0,0,0-.7,1.891l6.531,5.595-6.531,5.592a1.067,1.067,0,1,0,1.386,1.616l7.477-6.4a1.067,1.067,0,0,0,0-1.624l-7.477-6.4a1.066,1.066,0,0,0-.684-.269Z",
    transform: "translate(-10.092 -1491.206)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_755",
    "data-name": "Mask Group 755",
    transform: "translate(212.529 515.5)",
    opacity: 0.8,
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_16_2",
    "data-name": "svgexport-7 (16)",
    transform: "translate(2.666 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1-2",
    "data-name": "layer1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9429-2",
    "data-name": "path9429",
    d: "M11.23,1491.206a1.067,1.067,0,0,0-.7,1.891l6.531,5.595-6.531,5.592a1.067,1.067,0,1,0,1.386,1.616l7.477-6.4a1.067,1.067,0,0,0,0-1.624l-7.477-6.4a1.066,1.066,0,0,0-.684-.269Z",
    transform: "translate(-10.092 -1491.206)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_756",
    "data-name": "Mask Group 756",
    transform: "translate(221.117 515.5)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_16_3",
    "data-name": "svgexport-7 (16)",
    transform: "translate(2.666 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1-3",
    "data-name": "layer1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9429-3",
    "data-name": "path9429",
    d: "M11.23,1491.206a1.067,1.067,0,0,0-.7,1.891l6.531,5.595-6.531,5.592a1.067,1.067,0,1,0,1.386,1.616l7.477-6.4a1.067,1.067,0,0,0,0-1.624l-7.477-6.4a1.066,1.066,0,0,0-.684-.269Z",
    transform: "translate(-10.092 -1491.206)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupArrs);
export default __webpack_public_path__ + "static/media/signup-arrs.e309ed3081e06bad88233ee53cc2d75f.svg";
export { ForwardRef as ReactComponent };